export const BASE_URL = "https://mdss.genkagi.com/admin/";
export const BASE_IMAGE_URL = "https://mdss.genkagi.com/"

// export const BASE_URL = "http://192.168.10.60:5050/admin/";
// export const BASE_IMAGE_URL = "http://192.168.10.60:5050/";
export const PAGELENGTH = 10

export const USER_DATA = "user_data"
export const IS_LOGIN = "is_login"
export const IS_ADDED = "is_added"
export const FINANCIAL_YEAR = "financial_year"
export const IS_ADMIN = "is_school_admin"

export const DASHBOARD = "dashboard"
export const COMPANY_DASHBOARD = "dashboard/company"

export const LOGIN = "login"
export const LOGOUT = "logout"

export const SEND_OTP = 'sendotp/company'
export const VERIFY_OTP = 'verifyotp/company'
export const FORGOT_PASSWORD = 'forgotPassword/company'
export const CHANGE_PASSWORD = 'changePassword/company'


export const PROFILE = "admin/myschoolprofile"
export const UPDATE_PROFILE = "admin/updateschool"
export const ADD_PROFILE = "admin/addschool"


export const ALL_ROLES = "role/all"
export const ADD_ROLES = "role/add"
export const UPDATE_ROLES = "role/update"
export const DELETE_ROLES = "role/delete"
export const SINGLE_ROLE = "role/single"

export const ALL_USERS = "user/all"
export const ADD_USERS = "user/add"
export const UPDATE_USERS = "user/update"
export const SINGLE_USERS = "user/single"
export const DELETE_USERS = "user/delete"
export const ENABLE_DISABLE_USERS = "user/enableDisable"

export const ALL_CUSTOMERS = "companyCustomers"
export const SINGLE_CUSTOMER = "customer/single"

export const ADD_CATEGORY = "category/add"
export const ALL_CATEGORIES = "category/all"
export const SINGLE_CATEGORY = "category/single"
export const UPDATE_CATEGORY = "category/update"
export const ENABLE_DISABLE_CATEGORY = "category/updateStatus"
export const ALL_CATEGORY_MINI = "category/allMini"


export const ALL_COMPANIES = "ward/all"
export const ADD_COMPANY = "ward/add"
export const SINGLE_COMPANY = "ward/single"
export const UPDATE_COMPANY = "ward/update"
export const ENABLE_DISABLE_COMPANY = "ward/updateStatus"
export const ALL_COMPANIES_MINI = "ward/allMini"


export const ALL_SAMPLES = "people/all"
export const ADD_SAMPLE = "people/add"
export const SINGLE_SAMPLE = "people/single"
export const UPDATE_SAMPLE = "people/update"
export const ENABLE_DISABLE_SAMPLE = "people/updateStatus"


export const REGISTER_DISTRIBUTOR = "distributor/add"
export const SINGLE_DISTRIBUTOR = "distributor/single"
export const GET_CITIES = "getCities"
export const GET_STATES = "getStates"
export const UPDATE_DISTRIBUTOR = "distributor/update"

export const ALL_COMPANY_DISTRIBUTORS = "companyDistributor/all"
export const ALL_COMPANY_DISTRIBUTORS_MINI = "companyDistributor/allMini"
export const ENABLE_DISABLE_DISTRIBUTOR = "companyDistributor/updateStatus"
export const ALL_DISTRIBUTORS = "distributorReport/all"
export const NOT_ASSIGNED_DIS_ALL = "notAssignedDistributor/all"

export const ISSUED_SAMPLE_ADD = "issuedSampleDistributor/update"
export const ALL_ISSUED_SAMPLE = "issuedSampleDistributor/all"
export const ALL_ISSUED_SAMPLE_DISTRIBUTOR = "issuedSampleDistributor/all"
export const ALL_ISSUED_SAMPLE_DISTRIBUTOR_TRANSACTION = "issuedSampleDistributor/transactions"
export const ALL_ISSUED_SAMPLE_TO_CUSTOMER = "issuedSampleToCustomer/all"
export const RTL_UNDER_WHL = "rtlUnderWhl/all"
export const RTL_UNDER_WHL_ADD = "rtlUnderWhl/add"
export const RTL_UNDER_WHL_UPDATE = "rtlUnderWhl/update"
export const RTL_UNDER_WHL_REMOVE = "rtlUnderWhl/remove"

export const CHANGE_DISTRIBUTOR_TYPE = "distributorType/change"
export const COMPANY_CUSTOMERS = "companyCustomers"

export const DISTRIBUTOR_SEARCH = "distributor/search"
export const COMPANY_DISTRIBUTOR_SEARCH = "companyDistributor/search"
export const COMPANY_ADD_EXISTING_DISTRIBUTOR = "companyDistributor/addExisting"

export const NO_ASSIGN_RTL_TO_DISTRIBUTOR = "companyDistributor/noWHLAssignToRTL"
export const SELECT_SINGLE_SAMPLE_FOR_ISSUE = "issuedSampleDistributor/singleIssued"
export const ISSUED_MULTIPLE_SAMPLE_TO_DIS = "issuedSampleDistributor/bulkIssuedByCompany"
export const CHECK_MULTIPLE_SAMPLE_BEFORE_ISSUE = "issuedSampleDistributor/checkBeforeBulkIssuedByCompany"


export const ALL_REGISTERED_CUSTOMERS = "customer/all"


export const SWITCH_DISTRIBUTOR = "rtlUnderWhl/update"


export const ADD_TREATMENT = 'treatment/add';
export const ADD_CATEGORY_LOGS = 'categorylogs/add';
export const ADD_WARD_LOGS = 'wardLog/add'

export const ALL_TREATMENT = 'treatment/all';
export const ALL_CATEGORY_LOGS = 'categorylogs/all';
export const ALL_WARD_LOGS = 'wardLog/all'


export const ADD_DISCHARGE = 'treatment/discharge'
export const BULK_ADD_PEOPLE = 'people/bulk'
export const SCAN_PEOPLE = 'scan'
export const MISSING_ALL = 'missing/all'






